import { Hit } from '../retrieval/hit-list.model';
import { DataEntryTemplate } from '../data-entry/data-entry-template.model';
import { ApplicationArchivePair } from '../shared/application.model';
import { Workitem } from '../workflow/workitem.model';

export class SourceDocumentIdentifier {
    MasterId: number = 0;
    Version: number = 0;
    KeyfileDocId: string = "";
    ContentServerId: string = "";
    VersionLabel: string = "";
    VersionCreated: Date | undefined;
    VersionCreatedDate: Date | undefined;
    VersionCreatorId: number = 0;
    VersionCreatorName: string = "";
    AnnotationCount: number = 0;
    Label: string = "";
    LabelId: number = 0;
    ApplicationArchiveInfo: ApplicationArchivePair | undefined;

    constructor() { }

    toString = (): string => {
        return `SourceDocumentIdentifier: (master ID: ${this.MasterId}, version: ${this.Version})`;
    }

    toUniqueId(): string {
        return `${this.MasterId}:${this.Version}`;
    }

    fromUniqueId(from: string) {
        let tokens = from.split(':');
        this.MasterId = Number(tokens[0]);
        this.Version = Number(tokens[1]);
    }
}

export class DocumentIdentifier extends SourceDocumentIdentifier {

    Suffix: number = 0;
    WorkflowError: string | null = "";

    constructor() {
        super();
    }

    toString = (): string => {
        return `DocumentIdentifier: (master ID: ${this.MasterId}, version: ${this.Version}, suffix: ${this.Suffix})`;
    }

    fromUniqueId(from: string): void {
        let tokens = from.split(':');
        this.MasterId = Number(tokens[0]);
        this.Version = Number(tokens[1]);
        this.Suffix = Number(tokens[2]);
    }

    fromHit(hit: Hit) {
        this.MasterId = hit.MasterId;
        this.Version = hit.Version;
        this.Suffix = hit.Suffix;
    }

    fromData(masterId: number, version: number, suffix: number) {
        this.MasterId = masterId;
        this.Version = version;
        this.Suffix = suffix;
    }

    toUniqueId(): string {
        return `${this.MasterId}:${this.Version}:${this.Suffix}`;
    }
}


export class FetchDocumentsMessage {
    DocumentsToFetch: SourceDocumentIdentifier[] = [];
    PackageFiles: GetDocumentItemsOptions = GetDocumentItemsOptions.None;
    ApplyAnnotations: boolean = true;
    RenderAsUserId: number = 0;
    RenderAsGroupId: number = 0;
    IsEditingSourceFiles: boolean = false;
    IsEmailing: boolean = false;
    IsPrinting: boolean = false;
    Pages: number[] = [];

    constructor() { }
}

export class DocumentIdentifierIndexDataChangeMessage {
    EntryTemplate: DataEntryTemplate | undefined;
    Document: DocumentIdentifier = new DocumentIdentifier();
    Documents: DocumentIdentifier[] = [];
    Workitem: Workitem | undefined;
    constructor() { }
}

export interface FetchDocumentResult {
    DocumentFetched: SourceDocumentIdentifier;
    UrlPages: {
        Key: number;
        Value: string;
    }[];
    Description: string;
}

export interface FetchDocumentsResult {
    DocumentResult: FetchDocumentResult[];
    Request: FetchDocumentsMessage;
    ViewerUrl: string;
    Warning: string;
}

export enum GetDocumentItemsOptions {
    None,
    IncludeDocumentSummary = 1 << 0,
    ConvertToPDF = 1 << 1,
    WithoutAnnotations = 1 << 2,
    ConvertToZIP = 1 << 3,
    DoNotConvertFromKeyfile = 1 << 4
}

export interface DeleteDocumentResult {
    ErrorMessage: string;
    Document: DocumentIdentifier;
}

export interface DeleteDocumentsResults {
    deleteResults: DeleteDocumentResult[];
}

export interface DeleteSourceDocumentResult {
    ErrorMessage: string;
    SourceDocument: SourceDocumentIdentifier;
}

export interface DeleteSourceDocumentsResults {
    deleteResults: DeleteSourceDocumentResult[];
}

export enum DocumentReserveType {
    NotReserved = 0,
    Reserved = 1,
    ReservedByCurrentUser = 2,
    LegalHold = 3,
    RecordsManagement = 4,
    Workflow = 5
}

export class DocumentCreateVersionFile {
    fileNumber: number = 0;
    filePath: string = "";
    constructor(pageNumber: number, filePath: string) {
        this.fileNumber = pageNumber;
        this.filePath = filePath;
    }
}
export interface DocumentCreateVersionFiles {
    files: DocumentCreateVersionFile[];
}

export class RoutingDetails {
    documents: DocumentIdentifier[] = [];
    users: number[] = [];
    groups: number[] = [];
}
